import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {axiosClient} from "../../axios/axiosClient";
import {getProducts} from "./productsSlice";

const initialState = {
    logs: [],
    logsPagination: {},
    logsLoading: null,
}


export const getLogs = createAsyncThunk(
    'products/logs',
    async function ({ page, brand, found, noBrand }, { rejectWithValue }) {
        try {
            const params = new URLSearchParams();
            params.append('page', page);
            if (brand) params.append('brand', brand);
            if (found !== undefined) params.append('found', found);
            if (noBrand) params.append('noBrand', 'true');

            const response = await axiosClient.get(`/products/logs?${params.toString()}`);
            if (response?.data) {
                return response.data;
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



const logSlice = createSlice({
    name: 'logs',
    initialState,
    reducers: {},
    extraReducers: {
        [getLogs.pending]: (state) => {
            state.logsLoading = 'loading';
        },
        [getLogs.fulfilled]: (state, action) => {
            state.logsLoading = 'success';
            state.logs = action.payload.data;
            state.notFoundCount = action.payload.notFoundCount;
            state.foundCount = action.payload.foundCount;
            state.logsPagination = {
                total: action.payload.total,
                page: action.payload.page,
                totalPages: action.payload.totalPages,
            };

        },
        [getLogs.rejected]: (state) => {
            state.logsLoading = 'error';
        },
    }
})

export const {}= logSlice.actions

export default logSlice.reducer
